/**
 * Append resource (script/link) to head element
 *
 * @param {HTMLElement} el Element to add to head
 */
const appendResource = function(el) {
    const headEl = document.getElementsByTagName('head')[0]
    headEl.parentNode.append(el)
}

/**
 * Load plugin script
 *
 * @param {{url: {string}, style: {string}}} pluginConfig Plugin configuration object
 *
 * @return {Promise<*>}
 */
const loadScript = function(pluginConfig) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.async = true
        script.src = pluginConfig.url

        // Resolve the promise once the script is loaded
        script.addEventListener('load', resolve)

        // Catch any errors while loading the script
        script.addEventListener('error', () => {
            console.error(`Plugin from <${pluginConfig.url}> failed to load.`)
            reject()
        })

        appendResource(script)
    })
}

/**
 * Load enabled plugin style if it has a style
 *
 * @param {{url: {string}, style: {string}}} pluginConfig Plugin configuration object
 *
 * @return {Promise<*>}
 */
const loadStyle = function(pluginConfig) {
    if (!pluginConfig.style) {
        return Promise.resolve()
    }

    return new Promise(resolve => {
        const link = document.createElement('link')
        link.type = 'text/css'
        link.rel = 'stylesheet'
        link.href = pluginConfig.style

        appendResource(link)

        // HACK: Link element does not fire onload event, so we fire it manually
        setTimeout(() => {
            resolve()
        }, 10)
    })
}

export {loadScript, loadStyle}
